import React from 'react'
import { withPrefix } from 'gatsby'
import s from './products.module.css'
import { GTMEvents } from '../../../lib/GTMevents'
import Btn from '../../buttons/buttons'

const Products = () => {
  return (
    <div className={'containerWrap'}>
      <div
        className={`center font-family-primary c-black-0 tw-f-18 tw-f-18@lg tw-mb-2`}
      >
        Nuestro propósito es guiarte y acompañarte
      </div>

      <h2
        className={`center font-family-secondary tw-f-20 tw-f-24@lg tw-mt-0 tw-mb-12`}
      >
        Estos son los productos que tenemos para tí
      </h2>

      <div className="tw-p-8 tw-p-8@lg bg-turquoise-1 center left@lg brad-4">
        <div className={`flex direction-column direction-row@lg items-center`}>
          <div
            className={`w-100 w-50@lg order-1 order-1@lg center tw-mb-12 tw-mb-0@lg`}
          >
            <img
              src={withPrefix('/images/couple_journey2.svg')}
              alt=""
              className={`${s.imagenBox1} db dn@lg`}
            />

            <img
              src={withPrefix('/images/couple-vacation.svg')}
              alt=""
              className={`${s.imagenBox1} dn db@lg`}
            />
          </div>

          <div
            className={`w-100 w-50@lg order-2 order-2@lg tw-mb-0 tw-mb-0@lg`}
          >
            <h3 className="tw-mt-0 font-family-secondary c-gray--4 fw-7 tw-f-20 tw-f-20@lg tw-mb-2 tw-mb-4@lg left">
              Cuenta metas
            </h3>

            <div className="left tw-mb-8 tw-pr-10@lg">
              <ul
                className={`font-family-primary tw-f-16 bulletList-0 tw-pr-4@lg`}
              >
                <li>Aporta el monto que tú desees, no hay mínimo ni máximo.</li>
                <li>
                  Realiza todos los retiros que desees. No hay un mínimo de
                  permanencia.
                </li>
                <li>
                  Convierte tus aportes de Cuenta metas en aportes para tu
                  jubilación.
                </li>
              </ul>
            </div>

            <div onClick={() => GTMEvents.BtnProductsHome()}>
              <Btn
                type="link"
                href="/productos/cuenta-metas/"
                target="_blank"
                size="medium"
                label="Crear mi meta"
                className="font-family-secondary brad-3 brab@lg tw-f-16 tw-px-8 tw-py-3 center m-auto tw-ml-0@md w-100 w-auto@lg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Products
